import {
  GET_PROJECTS,
  GET_PROJECTS_SUCCESS,
  GET_PROJECTS_FAIL,
  GET_PROJECTS_RESET,
  CREATE_PROJECT,
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_FAIL,
  CREATE_PROJECT_RESET,
  GET_PROJECT_BY_ID,
  GET_PROJECT_BY_ID_SUCCESS,
  GET_PROJECT_BY_ID_FAIL,
  GET_PROJECT_BY_ID_RESET,
  UPDATE_PROJECT,
  UPDATE_PROJECT_SUCCESS,
  UPDATE_PROJECT_FAIL,
  UPDATE_PROJECT_RESET,
  DELETE_PROJECT,
  DELETE_PROJECT_SUCCESS,
  DELETE_PROJECT_FAIL,
  DELETE_PROJECT_RESET,
  GET_PROJECT_FILES,
  GET_PROJECT_FILES_SUCCESS,
  GET_PROJECT_FILES_FAIL,
  GET_PROJECT_FILES_RESET,
  UPLOAD_PROJECT_FILE,
  UPLOAD_PROJECT_FILE_SUCCESS,
  UPLOAD_PROJECT_FILE_FAIL,
  UPLOAD_PROJECT_FILE_RESET,
  DELETE_PROJECT_FILE,
  DELETE_PROJECT_FILE_SUCCESS,
  DELETE_PROJECT_FILE_FAIL,
  DELETE_PROJECT_FILE_RESET,
  GENERATE_UPLOAD_URLS,
  GENERATE_UPLOAD_URLS_SUCCESS,
  GENERATE_UPLOAD_URLS_FAIL,
  GENERATE_UPLOAD_URLS_RESET,
  BULK_UPLOAD_PROGRESS,
  BULK_UPLOAD_COMPLETE,
  BULK_UPLOAD_RESET,
  UPDATE_PROJECT_SETTINGS,
  UPDATE_PROJECT_SETTINGS_SUCCESS,
  UPDATE_PROJECT_SETTINGS_FAIL,
  UPDATE_PROJECT_SETTINGS_RESET,
  GET_PROJECT_SHARES,
  GET_PROJECT_SHARES_SUCCESS,
  GET_PROJECT_SHARES_FAIL,
  GET_PROJECT_SHARES_RESET,
  SHARE_PROJECT,
  SHARE_PROJECT_SUCCESS,
  SHARE_PROJECT_FAIL,
  SHARE_PROJECT_RESET,
  UPDATE_PROJECT_SHARE,
  UPDATE_PROJECT_SHARE_SUCCESS,
  UPDATE_PROJECT_SHARE_FAIL,
  UPDATE_PROJECT_SHARE_RESET,
  REMOVE_PROJECT_SHARE,
  REMOVE_PROJECT_SHARE_SUCCESS,
  REMOVE_PROJECT_SHARE_FAIL,
  REMOVE_PROJECT_SHARE_RESET,
  GET_ELIGIBLE_CAMPAIGNS,
  GET_ELIGIBLE_CAMPAIGNS_SUCCESS,
  GET_ELIGIBLE_CAMPAIGNS_FAIL,
  GET_ELIGIBLE_CAMPAIGNS_RESET,
  CREATE_PROJECT_FROM_CAMPAIGN,
  CREATE_PROJECT_FROM_CAMPAIGN_SUCCESS,
  CREATE_PROJECT_FROM_CAMPAIGN_FAIL,
  CREATE_PROJECT_FROM_CAMPAIGN_RESET,
  GET_ELIGIBLE_STUDIES,
  GET_ELIGIBLE_STUDIES_SUCCESS,
  GET_ELIGIBLE_STUDIES_FAIL,
  GET_ELIGIBLE_STUDIES_RESET,
  IMPORT_FROM_STUDIES,
  IMPORT_FROM_STUDIES_SUCCESS,
  IMPORT_FROM_STUDIES_FAIL,
  IMPORT_FROM_STUDIES_RESET,
} from '../actions/projectAction';

const initialState = {
  getProjectsState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  createProjectState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getProjectByIdState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  updateProjectState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  deleteProjectState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getProjectFilesState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  uploadProjectFileState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  deleteProjectFileState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  bulkUploadState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
    progress: {
      completed: 0,
      total: 0,
      percentage: 0,
    },
  },
  updateProjectSettingsState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getProjectSharesState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  shareProjectState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  updateProjectShareState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  removeProjectShareState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getEligibleCampaignsState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  createProjectFromCampaignState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getEligibleStudiesState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  importFromStudiesState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
};

const projectReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROJECTS:
      return {
        ...state,
        getProjectsState: {
          ...state.getProjectsState,
          apiState: 'loading',
        },
      };
    case GET_PROJECTS_SUCCESS:
      return {
        ...state,
        getProjectsState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Projects retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_PROJECTS_FAIL:
      return {
        ...state,
        getProjectsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch projects',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_PROJECTS_RESET:
      return {
        ...state,
        getProjectsState: initialState.getProjectsState,
      };

    case CREATE_PROJECT:
      return {
        ...state,
        createProjectState: {
          ...state.createProjectState,
          apiState: 'loading',
        },
      };
    case CREATE_PROJECT_SUCCESS:
      return {
        ...state,
        createProjectState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Project created successfully',
          errors: action.response.errors || null,
        },
      };
    case CREATE_PROJECT_FAIL:
      return {
        ...state,
        createProjectState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to create project',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case CREATE_PROJECT_RESET:
      return {
        ...state,
        createProjectState: initialState.createProjectState,
      };

    case GET_PROJECT_BY_ID:
      return {
        ...state,
        getProjectByIdState: {
          ...state.getProjectByIdState,
          apiState: 'loading',
        },
      };
    case GET_PROJECT_BY_ID_SUCCESS:
      return {
        ...state,
        getProjectByIdState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Project retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_PROJECT_BY_ID_FAIL:
      return {
        ...state,
        getProjectByIdState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch project',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_PROJECT_BY_ID_RESET:
      return {
        ...state,
        getProjectByIdState: initialState.getProjectByIdState,
      };

    case UPDATE_PROJECT:
      return {
        ...state,
        updateProjectState: {
          ...state.updateProjectState,
          apiState: 'loading',
        },
      };
    case UPDATE_PROJECT_SUCCESS:
      return {
        ...state,
        updateProjectState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Project updated successfully',
          errors: action.response.errors || null,
        },
      };
    case UPDATE_PROJECT_FAIL:
      return {
        ...state,
        updateProjectState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to update project',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case UPDATE_PROJECT_RESET:
      return {
        ...state,
        updateProjectState: initialState.updateProjectState,
      };

    case DELETE_PROJECT:
      return {
        ...state,
        deleteProjectState: {
          ...state.deleteProjectState,
          apiState: 'loading',
        },
      };
    case DELETE_PROJECT_SUCCESS:
      return {
        ...state,
        deleteProjectState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Project deleted successfully',
          errors: action.response.errors || null,
        },
      };
    case DELETE_PROJECT_FAIL:
      return {
        ...state,
        deleteProjectState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to delete project',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case DELETE_PROJECT_RESET:
      return {
        ...state,
        deleteProjectState: initialState.deleteProjectState,
      };

    case GET_PROJECT_FILES:
      return {
        ...state,
        getProjectFilesState: {
          ...state.getProjectFilesState,
          apiState: 'loading',
        },
      };
    case GET_PROJECT_FILES_SUCCESS:
      return {
        ...state,
        getProjectFilesState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Files retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_PROJECT_FILES_FAIL:
      return {
        ...state,
        getProjectFilesState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch files',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_PROJECT_FILES_RESET:
      return {
        ...state,
        getProjectFilesState: initialState.getProjectFilesState,
      };

    case UPLOAD_PROJECT_FILE:
      return {
        ...state,
        uploadProjectFileState: {
          ...state.uploadProjectFileState,
          apiState: 'loading',
        },
      };
    case UPLOAD_PROJECT_FILE_SUCCESS:
      return {
        ...state,
        uploadProjectFileState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'File uploaded successfully',
          errors: action.response.errors || null,
        },
      };
    case UPLOAD_PROJECT_FILE_FAIL:
      return {
        ...state,
        uploadProjectFileState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to upload file',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case UPLOAD_PROJECT_FILE_RESET:
      return {
        ...state,
        uploadProjectFileState: initialState.uploadProjectFileState,
      };

    case DELETE_PROJECT_FILE:
      return {
        ...state,
        deleteProjectFileState: {
          ...state.deleteProjectFileState,
          apiState: 'loading',
        },
      };
    case DELETE_PROJECT_FILE_SUCCESS:
      return {
        ...state,
        deleteProjectFileState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'File deleted successfully',
          errors: action.response.errors || null,
        },
      };
    case DELETE_PROJECT_FILE_FAIL:
      return {
        ...state,
        deleteProjectFileState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to delete file',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case DELETE_PROJECT_FILE_RESET:
      return {
        ...state,
        deleteProjectFileState: initialState.deleteProjectFileState,
      };

    case GENERATE_UPLOAD_URLS:
      return {
        ...state,
        bulkUploadState: {
          ...state.bulkUploadState,
          apiState: 'loading',
          progress: { completed: 0, total: 0, percentage: 0 },
        },
      };
    case GENERATE_UPLOAD_URLS_SUCCESS:
      return {
        ...state,
        bulkUploadState: {
          ...state.bulkUploadState,
          apiState: 'uploading',
          data: action.response,
        },
      };
    case GENERATE_UPLOAD_URLS_FAIL:
      return {
        ...state,
        bulkUploadState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to generate upload URLs',
          errors: action.response?.errors || null,
          error: action.response,
          progress: { completed: 0, total: 0, percentage: 0 },
        },
      };
    case GENERATE_UPLOAD_URLS_RESET:
      return {
        ...state,
        bulkUploadState: initialState.bulkUploadState,
      };
    case BULK_UPLOAD_PROGRESS:
      return {
        ...state,
        bulkUploadState: {
          ...state.bulkUploadState,
          apiState: 'uploading',
          progress: action.progress,
        },
      };
    case BULK_UPLOAD_COMPLETE:
      return {
        ...state,
        bulkUploadState: {
          apiState: 'success',
          data: action.response,
          message: action.response?.message || 'Files uploaded successfully',
          errors: null,
          error: null,
          progress: { completed: 0, total: 0, percentage: 100 },
        },
      };
    case BULK_UPLOAD_RESET:
      return {
        ...state,
        bulkUploadState: initialState.bulkUploadState,
      };

    case UPDATE_PROJECT_SETTINGS:
      return {
        ...state,
        updateProjectSettingsState: {
          ...state.updateProjectSettingsState,
          apiState: 'loading',
        },
      };
    case UPDATE_PROJECT_SETTINGS_SUCCESS:
      return {
        ...state,
        updateProjectSettingsState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Settings updated successfully',
          errors: action.response.errors || null,
        },
      };
    case UPDATE_PROJECT_SETTINGS_FAIL:
      return {
        ...state,
        updateProjectSettingsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to update settings',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case UPDATE_PROJECT_SETTINGS_RESET:
      return {
        ...state,
        updateProjectSettingsState: initialState.updateProjectSettingsState,
      };

    // Project Sharing
    case GET_PROJECT_SHARES:
      return {
        ...state,
        getProjectSharesState: {
          ...state.getProjectSharesState,
          apiState: 'loading',
        },
      };
    case GET_PROJECT_SHARES_SUCCESS:
      return {
        ...state,
        getProjectSharesState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Shares retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_PROJECT_SHARES_FAIL:
      return {
        ...state,
        getProjectSharesState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch shares',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_PROJECT_SHARES_RESET:
      return {
        ...state,
        getProjectSharesState: initialState.getProjectSharesState,
      };

    case SHARE_PROJECT:
      return {
        ...state,
        shareProjectState: {
          ...state.shareProjectState,
          apiState: 'loading',
        },
      };
    case SHARE_PROJECT_SUCCESS:
      return {
        ...state,
        shareProjectState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Project shared successfully',
          errors: action.response.errors || null,
        },
      };
    case SHARE_PROJECT_FAIL:
      return {
        ...state,
        shareProjectState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to share project',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case SHARE_PROJECT_RESET:
      return {
        ...state,
        shareProjectState: initialState.shareProjectState,
      };

    case UPDATE_PROJECT_SHARE:
      return {
        ...state,
        updateProjectShareState: {
          ...state.updateProjectShareState,
          apiState: 'loading',
        },
      };
    case UPDATE_PROJECT_SHARE_SUCCESS:
      return {
        ...state,
        updateProjectShareState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Share updated successfully',
          errors: action.response.errors || null,
        },
      };
    case UPDATE_PROJECT_SHARE_FAIL:
      return {
        ...state,
        updateProjectShareState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to update share',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case UPDATE_PROJECT_SHARE_RESET:
      return {
        ...state,
        updateProjectShareState: initialState.updateProjectShareState,
      };

    case REMOVE_PROJECT_SHARE:
      return {
        ...state,
        removeProjectShareState: {
          ...state.removeProjectShareState,
          apiState: 'loading',
        },
      };
    case REMOVE_PROJECT_SHARE_SUCCESS:
      return {
        ...state,
        removeProjectShareState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Share removed successfully',
          errors: action.response.errors || null,
        },
      };
    case REMOVE_PROJECT_SHARE_FAIL:
      return {
        ...state,
        removeProjectShareState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to remove share',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case REMOVE_PROJECT_SHARE_RESET:
      return {
        ...state,
        removeProjectShareState: initialState.removeProjectShareState,
      };

    // Eligible Campaigns for Project
    case GET_ELIGIBLE_CAMPAIGNS:
      return {
        ...state,
        getEligibleCampaignsState: {
          ...state.getEligibleCampaignsState,
          apiState: 'loading',
        },
      };
    case GET_ELIGIBLE_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        getEligibleCampaignsState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Campaigns retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_ELIGIBLE_CAMPAIGNS_FAIL:
      return {
        ...state,
        getEligibleCampaignsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch campaigns',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_ELIGIBLE_CAMPAIGNS_RESET:
      return {
        ...state,
        getEligibleCampaignsState: initialState.getEligibleCampaignsState,
      };

    // Create Project from Campaign
    case CREATE_PROJECT_FROM_CAMPAIGN:
      return {
        ...state,
        createProjectFromCampaignState: {
          ...state.createProjectFromCampaignState,
          apiState: 'loading',
        },
      };
    case CREATE_PROJECT_FROM_CAMPAIGN_SUCCESS:
      return {
        ...state,
        createProjectFromCampaignState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Project created successfully',
          errors: action.response.errors || null,
        },
      };
    case CREATE_PROJECT_FROM_CAMPAIGN_FAIL:
      return {
        ...state,
        createProjectFromCampaignState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to create project',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case CREATE_PROJECT_FROM_CAMPAIGN_RESET:
      return {
        ...state,
        createProjectFromCampaignState: initialState.createProjectFromCampaignState,
      };

    // Get Eligible Studies for Import
    case GET_ELIGIBLE_STUDIES:
      return {
        ...state,
        getEligibleStudiesState: {
          ...state.getEligibleStudiesState,
          apiState: 'loading',
        },
      };
    case GET_ELIGIBLE_STUDIES_SUCCESS:
      return {
        ...state,
        getEligibleStudiesState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Studies retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_ELIGIBLE_STUDIES_FAIL:
      return {
        ...state,
        getEligibleStudiesState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch studies',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_ELIGIBLE_STUDIES_RESET:
      return {
        ...state,
        getEligibleStudiesState: initialState.getEligibleStudiesState,
      };

    // Import from Studies
    case IMPORT_FROM_STUDIES:
      return {
        ...state,
        importFromStudiesState: {
          ...state.importFromStudiesState,
          apiState: 'loading',
        },
      };
    case IMPORT_FROM_STUDIES_SUCCESS:
      return {
        ...state,
        importFromStudiesState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Transcripts imported successfully',
          errors: action.response.errors || null,
        },
      };
    case IMPORT_FROM_STUDIES_FAIL:
      return {
        ...state,
        importFromStudiesState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to import transcripts',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case IMPORT_FROM_STUDIES_RESET:
      return {
        ...state,
        importFromStudiesState: initialState.importFromStudiesState,
      };

    default:
      return state;
  }
};

export default projectReducer;
